import { adminStatsQueries } from "$/lib/queries/admin-stats-queries"
import { statsSearchSchema } from "$/lib/stats-search"
import { TaskEffortPeriodDaysSchema } from "@repo/common"
import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/task-effort")({
  validateSearch: statsSearchSchema.extend({
    days: TaskEffortPeriodDaysSchema.optional().catch(undefined),
  }),
  search: {
    middlewares: [retainSearchParams(["storeIds"])],
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(adminStatsQueries.stores())
    return { crumb: "Klickeffekt" }
  },
})
